import { render, staticRenderFns } from "./beneficiarySummary.vue?vue&type=template&id=0523c714&scoped=true"
import script from "./beneficiarySummary.vue?vue&type=script&lang=js"
export * from "./beneficiarySummary.vue?vue&type=script&lang=js"
import style0 from "./beneficiarySummary.vue?vue&type=style&index=0&id=0523c714&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0523c714",
  null
  
)

export default component.exports